<template>
  <!--  <svg :style="styleObject" viewBox="0 0 32 32">-->
  <!--    <use :xlink:href="`${url}#img`"></use>-->
  <!--  </svg>-->
  <picture>
    <source :media="`${url}`" />
  </picture>
</template>

<script>
import common from '@/mixins/common';

export default {
  mixins: [common],
  props: {
    svgIcon: String,
    invertImgIcons: { type: Boolean, default: false },
    /**
     * functional color like "primary" with an additional space separated color modifier like "lighten-1" (1-4 allowed)
     * or "darken-1" (1-4 allowed)
     */
    iconColor: {
      type: String,
      default: '',
    },
    /**
     * CSS Color will preceed iconColor
     */
    color: {
      type: String,
    },
  },
  data() {
    return {
      styleObject: {
        color: this.color ? this.color + ' !important' : null,
        fontSize: this.fontSize,
        filter: this.invertImgIcons ? 'invert(1) opacity(90%)' : null,
        height: '24px',
        paddingRight: '4px',
      },
    };
  },
  computed: {
    url() {
      return this.assetUrl(this.svgIcon);
    },
  },
};
</script>

<style></style>
